import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleDescriptionMC from '../../components/TitleDescriptionMC';
import ButtonComponent from '../../components/ButtonMC';
import { useFormContext } from 'react-hook-form';

const SelectFunnelStepByType = () => {
  const { t } = useTranslation('Funnels');

  const { setValue } = useFormContext();

  return (
    <div className="tw-wrapper">
      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stepTwo.fields.title')}
        description={t('sidebar.createFromZero.stepTwo.fields.subtitle')}
      />
      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stepTwo.fields.titleOpenSteps')}
        description={t('sidebar.createFromZero.stepTwo.fields.subtitleOpenSteps')}
        className="tw-mt-6"
      />
      <ButtonComponent
        text={t('sidebar.createFromZero.stepTwo.fields.buttonOpenSteps')}
        variant="SECONDARY"
        className="tw-w-full tw-mt-2"
        iconPosition="left"
        icon="plus-outline"
        iconClassName="tw-mt-[2px]"
        onClick={() => {
          setValue('type_step', 'step', { shouldDirty: true, shouldValidate: true });
        }}
        outlined
      />
      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stepTwo.fields.titleClosedSteps')}
        description={t('sidebar.createFromZero.stepTwo.fields.subtitleClosedSteps')}
        className="tw-mt-6"
      />
      <ButtonComponent
        text={t('sidebar.createFromZero.stepTwo.fields.buttonClosedSteps')}
        variant="SECONDARY"
        className="tw-w-full tw-mt-2"
        iconPosition="left"
        icon="plus-outline"
        iconClassName="tw-mt-[2px]"
        onClick={() => {
          setValue('type_step', 'won', { shouldDirty: true, shouldValidate: true });
        }}
        outlined
      />
    </div>
  );
};

export default SelectFunnelStepByType;
